module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "menu-header lg"
  }, [_vm._v("vConnect command reference")]), _vm._m(0), _vm._l((_vm.apiData), function(section) {
    return _c('div', [_c('span', {
      staticClass: "menu-header lg"
    }, [_vm._v(_vm._s(section.section))]), (section.description) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.description)
      }
    }) : _vm._e(), _vm._l((section.commands), function(cmd, cmdName) {
      return _c('div', [_c('h4', {
        staticClass: "txt-bold",
        attrs: {
          "id": 'about-' + cmdName
        }
      }, [_vm._v(_vm._s(cmdName))]), _c('p'), _c('div', {
        staticClass: "command-params"
      }, _vm._l((cmd.usage), function(usage) {
        return _c('p', {
          staticClass: "usage"
        }, [_vm._v(_vm._s(usage))])
      })), _c('p'), _c('p', {
        domProps: {
          "innerHTML": _vm._s(cmd.description)
        }
      }), _c('p', [_c('strong', [_vm._v("Example:  ")]), _vm._v(_vm._s(cmd.example.description) + ".")]), _c('pre', {
        directives: [{
          name: "syntax-highlight",
          rawName: "v-syntax-highlight",
          value: (cmd.example.code),
          expression: "cmd.example.code"
        }]
      }), _c('p', [_c('router-link', {
        staticClass: "read-more",
        attrs: {
          "to": 'api/' + cmdName
        }
      }, [_vm._v("Read more about this command →")])], 1), _c('hr', {
        staticClass: "command-split"
      })])
    })], 2)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-soft"
  }, [_c('strong', [_vm._v("Does this documentation look familiar?")]), _c('p', [_vm._v("It has been intentionally modeled after the RethinkDB documentation because the command structure was modeled after RethinkDB itself.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d967cd5a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SummaryApiDoc.vue
// module id = 171
// module chunks = 1